import { useEffect, useState } from "react";
import { BiEdit } from "react-icons/bi";
import { AiFillDelete } from "react-icons/ai";
import { ExclamationCircleFilled } from "@ant-design/icons";
import { Link } from "react-router-dom";
import { useNavigate } from "react-router-dom";

import { Modal, Row, Col } from "antd";
import { useDispatch, useSelector } from "react-redux";
import { setAllEmployees } from "../../redux/actions/mainAction";
import noemployee from "../../images/noemployee.gif";

const { confirm } = Modal;

const EmployeesTable = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const { GlobalResponse } = useSelector((state) => state);
  const { MainResponse } = useSelector((state) => state);

  const [page, setPage] = useState(1);
  const [totalPages, setTotalPages] = useState(0);

  useEffect(() => {
    getEmployees(page);
  }, [GlobalResponse.triggeranyevent, page]);

  const getEmployees = async (page) => {
    try {
      const response = await fetch(
        `${process.env.REACT_APP_BACKEND_URL}/get-employees/?page=${page}`,
        {
          headers: {
            authorization: `bearer ${JSON.parse(
              localStorage.getItem("token")
            )} `,
          },
        }
      );
      const result = await response.json();
      dispatch(setAllEmployees(result.employees));
      setTotalPages(result.totalPages);
    } catch (error) {
      console.log(error);
    }
  };

  const showDeleteConfirm = (employee) => {
    if (employee.appRole === "User") {
      confirm({
        centered: "centered",
        title: employee.employeeName,
        icon: <ExclamationCircleFilled />,
        content: "Əməkdaşı silmək istədiyinizdən əminsiniz?",
        okText: "Sil",
        okType: "danger",
        cancelText: "İmtina Et",
        onOk() {
          deleteEmployee(employee);
        },
        onCancel() {
          console.log("Cancel");
        },
      });
    } else {
      confirm({
        centered: "centered",
        title: employee.employeeName + " admin vəzifəsindədir!",
        icon: <ExclamationCircleFilled />,
        content:
          "Admin silinə bilməz! Onun vəzifəsini əməkdaş etdikdən sonra silə bilərsiniz!",
        okText: "Oldu",
        okType: "danger",
        cancelText: "Adminlər",
        onOk() {},
        onCancel() {
          navigate("/admins");
        },
      });
    }
  };

  const deleteEmployee = async (employee) => {
    const _id = employee._id;
    const companyName = employee.companyName;
    const departmentName = employee.departmentName;
    const positionName = employee.positionName;

    let result = await fetch(
      `${process.env.REACT_APP_BACKEND_URL}/employee/${_id}?companyName=${companyName}&departmentName=${departmentName}&positionName=${positionName}`,
      {
        method: "delete",
        headers: {
          authorization: `bearer ${JSON.parse(localStorage.getItem("token"))} `,
        },
      }
    );

    result = await result.json();
    console.log(result);
    if (result) {
      getEmployees(page);
    }
  };

  const handlePageChange = (newPage) => {
    setPage(newPage);
  };

  return (
    <>
      {MainResponse.allEmployees.length > 0 ? (
        <table>
          <thead>
            <tr>
              <th>#</th>
              <th>Ad və Soyad</th>
              <th>Şirkət</th>
              <th>Şöbə</th>
              <th>Vəzifə</th>
              <th>E-poçt</th>
              <th>Telefon</th>
              <th>Əməliyyat</th>
            </tr>
          </thead>
          {MainResponse.allEmployees.map((employee, index) => (
            <tbody key={employee._id}>
              <tr>
                <td>{employee._id}</td>
                <td>{employee.employeeName}</td>
                <td>{employee.companyName}</td>
                <td>{employee.departmentName}</td>
                <td>{employee.positionName}</td>
                <td>{employee.employeeEmail}</td>
                <td>{employee.employeePhone}</td>
                <td>
                  <Link
                    state={{ id: employee._id }}
                    className="btn"
                    to="/employeeedit"
                  >
                    {<BiEdit />}
                  </Link>

                  <Link
                    onClick={() => showDeleteConfirm(employee)}
                    className="btn-del"
                  >
                    {<AiFillDelete />}
                  </Link>
                </td>
              </tr>
            </tbody>
          ))}
        </table>
      ) : (
        <div className="no-item">
          <Row>
            <Col span={24}>
              <div className="no-item">
                <img
                  style={{ width: "280px" }}
                  src={noemployee}
                  alt="noemployee"
                />
              </div>
            </Col>
          </Row>
        </div>
      )}

      {totalPages > 0 && (
        <div className="pagination">
          <button
            disabled={page === 1}
            onClick={() => handlePageChange(page - 1)}
          >
            Əvvəlki
          </button>
          {[...Array(totalPages)].map((_, index) => (
            <button
              key={index + 1}
              className={page === index + 1 ? "active" : ""}
              onClick={() => handlePageChange(index + 1)}
            >
              {index + 1}
            </button>
          ))}
          <button
            disabled={page === totalPages}
            onClick={() => handlePageChange(page + 1)}
          >
            Növbəti
          </button>
        </div>
      )}
    </>
  );
};

export default EmployeesTable;
